import { of } from "rxjs";
import { catchError, filter, map, mergeMap } from "rxjs/operators";

import { Effect } from "../../../redux/types/effect.type";
import { EffectActionsObservable } from "../../../redux/types/effect-actions-observable.type";
import { isActionType } from "../../../redux/action.functions";

import * as appSearchService from "../services/app-search.service";
import { mapPayloadData } from "../services/app-search.service";

import * as actions from "./app-search.actions";
import { AppSearchActions } from "./app-search.actions";

const search: Effect = (action$: EffectActionsObservable) =>
  action$.pipe(
    filter(isActionType(AppSearchActions.Search)),
    map((action) => action.payload),
    mergeMap(({ endpoint, dataKey, params }) =>
      appSearchService.searchApp(endpoint, dataKey, params).pipe(
        map((results) => actions.searchAppSuccess(mapPayloadData(results, dataKey))),
        catchError((error) => of(actions.searchAppFailure(error)))
      )
    )
  );

export const AppSearchEffects = [search];
